module.exports = __webpack_public_path__ + "static/media/banner-gs.fe270bfc.png";